import React from 'react';

// project-import
import StencilBox from '../stencils/StencilBox';

const RegisterFormStencil = ({ formStyle }) => {

    return (
        <div className="login-form-box">
            <h3 className="mb-30">
                <StencilBox
                    width="100%"
                    height="56px"
                    backgroundColor="#F5F5F5"
                    border="none"
                />
            </h3>
            <form className={`${formStyle}`} action="">
                <div className="input-box mb--30">
                    <StencilBox
                        width="100%"
                        height="60px"
                        backgroundColor="#F5F5F5"
                        border="none"
                    />
                </div>
                <div className="input-box mb--30">

                    <StencilBox
                        width="100%"
                        height="60px"
                        backgroundColor="#F5F5F5"
                        border="none"
                    />
                </div>
                <div className="input-box mb--30">
                    <StencilBox
                        width="100%"
                        height="60px"
                        backgroundColor="#F5F5F5"
                        border="none"
                    />
                </div>
                <div className="input-box">
                    <StencilBox
                        width="100%"
                        height="26px"
                        backgroundColor="#F5F5F5"
                        border="none"
                    />
                </div>

                <StencilBox
                    width="100%"
                    height="60px"
                    backgroundColor="#F5F5F5"
                    border="none"
                />
            </form>
        </div>
    )
}
export default RegisterFormStencil;